<template>
    <article class="user-auth">
        <branding-bar></branding-bar>
        <div class="container-fluid">
            <div class="wrapper">
                <h1>Login</h1>
                <vue-form name="loginForm" class="" :state="formState" @submit.prevent="login()">
                    <div class="cm__login card">
                        <validate class="form-group">
                            <field-messages class="invalid-feedback" name="username" show="$dirty && $invalid && $touched">
                                <div slot="required">Email is a required field</div>
                                <div slot="email">Email is invalid</div>
                            </field-messages>
                            <input id="i__username" class="form-control" type="email" name="username" required placeholder="Email" v-model="username">
                            <label for="i__username">Email</label>
                        </validate>
                        <validate class="form-group">
                            <field-messages class="invalid-feedback" name="password" show="$dirty && $invalid && $touched">
                                <div slot="required">Password is a required field</div>
                            </field-messages>
                            <input id="i__password" class="form-control" name="password" required type="password" placeholder="Password" v-model="password">
                            <label for="i__password">Password</label>
                        </validate>
                        <div v-if="error" class="error  mb-15" role="alert">
                            {{ error }}
                        </div>
                        <div class="form-row">
                            <div class="col-md-6 mb-15">
                                <a href="/forgot-password">Forgotten password?</a>
                            </div>
                            <div class="form-group col-md-6 mb-15">
                                <button class="btn btn-primary c__save btn-block" :disabled="formState.$invalid"  type="submit">Login</button>
                            </div>
                        </div>
                    </div>
                </vue-form>
            </div>
        </div>
    </article>
</template>

<script>
    import brandingBar from './Header/branding-bar';
    import NavigationPerimeters from '../configs/Perimeters/navigation';
    import { mapGetters } from 'vuex';

    export default {
        perimeters: [NavigationPerimeters],
        components: {
            brandingBar
        },
        data () {
            return {
                formState: {},
                username: '',
                password: '',
                error: '',
                isInit: false,
                subdomain: null
            }
        },
        computed: {
            ...mapGetters(['getUser'])
        },
        methods: {
            login() {
                this.error = '';
                this.$store.dispatch('login', {
                    username: this.username,
                    password: this.password,
                }).then(() => {
                    let user = this.$store.getters.getUser;
                    this.$store.state.welcomeMsg = user.firstName;
                    if (user.role === 'ROLE_SUPER_ADMIN' ||
                        user.role === 'ROLE_ADMIN' ||
                        user.role === 'ROLE_CLIENT_ADMIN' ||
                        user.role === 'ROLE_AGENT_ADMIN'
                    ) {
                        this.$router.push('/offices');
                    } else if (user.permissions.canViewPastOrders) {
                        this.$router.push('/office/' + user.agency + '/campaigns');
                    } else if (user.permissions.canViewMediaOrders) {
                        this.$router.push('/office/' + user.agency + '/agent-campaigns/order');
                    } else {
                        this.password = '';
                        this.error = 'Please check your permissions';
                        this.formState._reset();
                    }
                    return;
                }).catch((errors) => {
                    this.password = '';
                    this.error = 'Either your email or password is incorrect';
                    this.formState._reset();
                });
            }
        },
        created(){
            this.subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : null;
            if (this.$store.getters.isLoggedIn) {
                let user = this.$store.getters.getUser;
                this.$store.state.welcomeMsg = user.firstName;
                if (user.role === 'ROLE_SUPER_ADMIN' ||
                    user.role === 'ROLE_ADMIN' ||
                    user.role === 'ROLE_CLIENT_ADMIN' ||
                    user.role === 'ROLE_AGENT_ADMIN'
                ) {
                    this.$router.push('/offices');
                } else if (user.permissions.canViewPastOrders) {
                    this.$router.push('/office/' + user.agency + '/campaigns');
                } else if (user.permissions.canViewMediaOrders) {
                    this.$router.push('/office/' + user.agency + '/agent-campaigns/order');
                } else {
                    this.password = '';
                    this.error = 'Please check your permissions';
                    this.formState._reset();
                }
            } else if (this.$route.query.reason && this.$route.query.reason !== 'success') {
                this.error = 'User denied request';
            }
	        if (this.$route.query.session === 'timeout') {
		        this.$swal({
			        type: 'warning',
			        heightAuto: false,
			        title: 'Session timeout',
			        text: `Please login`,
			        confirmButtonText: 'OK',
		        }).then((result) => {
			        if (result.value) {
				        this.$bus.$emit('bb:closeModal');
				        this.$emit('closeModal');
			        }
		        });
	        }
        }
    }

</script>